import ColorCurve from '@/assets/js/ColorCurve';

export default class Exposure {
	constructor() {
		this.minValue = -5;
		this.maxValue = 5;
		this.blockName = "exposure";
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let blockCanvasName = UI.createBlockCanvas(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find(".exposure_slider")
			.on("input", _ => this.exposureSliderHandler($(element)));
		$(element)
			.find(".exposure_range")
			.on("change", _ => this.exposureValueHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "exposure",
			curves: [
				{
					name: blockCanvasName,
					colorCurve: new ColorCurve(blockCanvasName),
				},
			],
			passes: [this.addExposurePass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			values: {
				exposure: 0,
			},
		});
	}

	addExposurePass() {
		let shaderPass = gpu.createCurveShaderPass(this.blockName);
		gpu.addPassToComposer(shaderPass, "toMiddle");
		return shaderPass;
	}

	exposureSliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let exposureValue = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, exposureValue);

		let block = lutify.getActiveBlock();
		block.values.exposure = exposureValue;
		this.curveExposure(block.values.exposure);
	}

	exposureValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let exposureValue = UI.getAdjustmentBlock_rangeValue($el);

		if (exposureValue > this.maxValue) {
			exposureValue = this.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, exposureValue);
		}
		if (exposureValue < this.minValue) {
			exposureValue = this.minValue;
			UI.setAdjustmentBlock_rangeValue($el, exposureValue);
		}

		UI.setAdjustmentBlock_sliderValue($el, exposureValue);
		lutify.getActiveBlock().values.exposure = exposureValue;
		this.curveExposure(lutify.getActiveBlock().values.exposure);
	}

	curveExposure(exposureValue) {
		let curve = lutify.getActiveBlock().curves[0].colorCurve;
		curve.points = [];

		if (exposureValue >= 0) {
			curve.points.push({ x: 0.0, y: 0.0 });
			curve.points.push({ x: 0.03, y: 0.03 - exposureValue * 0.006 });
			curve.points.push({ x: 0.06, y: 0.06 - exposureValue * 0.012 });
			curve.points.push({ x: 0.09, y: 0.09 + exposureValue * 0.051 });
			curve.points.push({ x: 0.69, y: 0.69 + exposureValue * 0.058 });
			curve.points.push({ x: 1.0, y: 1.0 });
		} else {
			curve.points.push({ x: 0.0, y: 0.0 + Math.abs(exposureValue) * 0.014 });
			curve.points.push({ x: 0.1, y: 0.1 - Math.abs(exposureValue) * 0.006 });
			curve.points.push({ x: 0.25, y: 0.25 - Math.abs(exposureValue) * 0.034 });
			curve.points.push({ x: 0.35, y: 0.35 - Math.abs(exposureValue) * 0.05 });
			curve.points.push({ x: 0.45, y: 0.45 - Math.abs(exposureValue) * 0.058 });
			curve.points.push({ x: 1.0, y: 1.0 - Math.abs(exposureValue) * 0.058 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUExposure(curve.rgb);
	}

	callGPUExposure(points) {
		let curveTexture = gpu.pointsToCurve(points);
		lutify.getActiveBlock().passes[0].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	applyChanges($block, values) {
		UI.setAdjustmentBlock_rangeValue($block, values.exposure);
		$block.find(".exposure_range").trigger("change");
	}
}
